// 계정-개인 권한 - 상수 및 Query Key 팩토리

// TanStack Query Key 컨벤션
export const ACCOUNT_PERMISSION_QK = {
  accountPermissions: (accountGuid: string) =>
    ["AccountPermissions", accountGuid] as const,
  accountEffective: (accountGuid: string) =>
    ["AccountEffective", accountGuid] as const,
};

// permissionGroup 코드 → UI 한글 라벨 매핑
// 백엔드 응답에 groupLabel이 별도로 없으면 이 맵을 사용
export const PERMISSION_GROUP_LABELS: Record<string, string> = {
  order: "주문/화물",
  dispatch: "배차",
  settlement: "정산",
  driver: "차주",
  "freight-owner": "화주",
  account: "계정/조직",
  admin: "관리자",
  report: "통계/리포트",
  pricing: "단가",
};

// 권한 그룹 표시 순서 (이 배열에 없는 그룹은 뒤에 입력 순서대로)
export const PERMISSION_GROUP_ORDER: string[] = [
  "order",
  "freight-owner",
  "settlement",
  "pricing",
  "account",
];

export function getPermissionGroupLabel(groupCode: string): string {
  return PERMISSION_GROUP_LABELS[groupCode] ?? groupCode;
}
